// Globaler User-Prefs-Cache. Wird einmal beim ersten useUserPrefs gefetched
// und bei jedem updatePreferences-Call aktualisiert (siehe Settings.tsx).

import { signal, type Signal } from "@preact/signals";
import { useEffect } from "preact/hooks";
import { DEFAULT_USER_PREFERENCES, type UserPreferences } from "@juuplan/shared";
import { fetchPreferences } from "./notifications";

const DEFAULTS: UserPreferences = DEFAULT_USER_PREFERENCES;

interface State {
  loading: boolean;
  prefs: UserPreferences;
  error: string | null;
}

const initial: State = { loading: true, prefs: DEFAULTS, error: null };
const prefsSignal: Signal<State> = signal(initial);
let inFlight: Promise<void> | null = null;

async function load(): Promise<void> {
  try {
    const prefs = await fetchPreferences();
    prefsSignal.value = { loading: false, prefs, error: null };
  } catch (err) {
    const msg = err instanceof Error ? err.message : "Unknown error";
    prefsSignal.value = { loading: false, prefs: DEFAULTS, error: msg };
  } finally {
    inFlight = null;
  }
}

export function useUserPrefs(): UserPreferences {
  useEffect(() => {
    if (!inFlight && prefsSignal.value.loading) {
      inFlight = load();
    }
  }, []);
  return prefsSignal.value.prefs;
}

export function setUserPrefs(prefs: UserPreferences): void {
  prefsSignal.value = { loading: false, prefs, error: null };
}
